import React, { useEffect, useState } from 'react';
import './ModalSistema.css';

function ModalRetomarAtendimento({
    open,
    onClose,
    onConfirm,
    loading = false,
    satNum,
}) {
    const [motivo, setMotivo] = useState('');
    const [erro, setErro] = useState('');

    useEffect(() => {
        if (!open) {
            setMotivo('');
            setErro('');
        }
    }, [open]);

    if (!open) return null;

    const handleConfirm = () => {
        const texto = motivo.trim();
        if (!texto) {
            setErro('Informe o motivo da retomada.');
            return;
        }
        if (typeof onConfirm === 'function') onConfirm(texto);
    };

    return (
        <div className="modal-sistema-overlay" onClick={loading ? undefined : onClose} role="dialog" aria-modal="true" aria-labelledby="modal-retomar-title">
            <div className="modal-sistema-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
                <h5 className="modal-sistema-title mb-2" id="modal-retomar-title">
                    Retomar atendimento{satNum ? ` — chamado #${satNum}` : ''}
                </h5>
                <p className="modal-sistema-message text-muted small mb-3">
                    O chamado voltará ao status aberto e o motivo será registrado no histórico. Confirme apenas se for necessário retomar o atendimento.
                </p>
                <div className="mb-3">
                    <label htmlFor="modal-retomar-motivo" className="form-label small mb-1">Motivo (obrigatório)</label>
                    <textarea
                        id="modal-retomar-motivo"
                        className="form-control form-control-sm"
                        rows={4}
                        value={motivo}
                        onChange={(e) => { setMotivo(e.target.value); if (erro) setErro(''); }}
                        placeholder="Ex.: Solicitante reportou que o problema voltou a ocorrer..."
                        disabled={loading}
                    />
                    {erro && <p className="text-danger small mb-0 mt-1">{erro}</p>}
                </div>
                <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-secondary btn-sm" onClick={onClose} disabled={loading}>Cancelar</button>
                    <button type="button" className="btn btn-primary btn-sm" onClick={handleConfirm} disabled={loading}>
                        {loading ? 'Retomando...' : 'Retomar atendimento'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalRetomarAtendimento;
